import { connect } from 'react-redux';

import NoResults from './noresults';

const mapStateToProps = state => ({
  programs: state.programs.filter(p => {
    return p.type === 'recommendations';
  }),
});

export default connect(mapStateToProps, null)(NoResults);
